import React, { useMemo, useState, useEffect } from 'react'
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Card from '../../../components/Card'

// img
// import facebook from '../../../assets/images/brands/fb.svg'
// import google from '../../../assets/images/brands/gm.svg'
// import instagram from '../../../assets/images/brands/im.svg'
// import linkedin from '../../../assets/images/brands/li.svg'
import auth1 from '../../../assets/images/auth/01.png'
import logoBrand from '../../../assets/images/brand/siapmutu-logo.png'
// import logoIcon from '../../../assets/images/brand/siapmutu-icon.png'
import logoIcon from '../../../assets/images/logo-3.png'
import UserService from '../../../services/user/UserService'
import SweetAlert from 'react-bootstrap-sweetalert'
// import logoKkp from '../../../assets/images/logo-kkp.png'
// import { FaChevronRight } from 'react-icons/fa'
import CaptchaCanvas from '../../../components/CaptchaCanvas'

import ForgotPasswordModal from '../Password/ForgotPassword'
import PbUmkuService from '../../../services/pbumku/PbumkuService'

const SignIn = () => {
   let history = useNavigate()
   const [username, setUsername] = useState('')
   const [password, setPassword] = useState('')
   let userService = useMemo(() => new UserService(), [])
   let pbumkuService = useMemo(() => new PbUmkuService(), [])

   const [showLoginSuccess, setShowLoginSuccess] = useState(false)
   const [showLoginFailed, setShowLoginFailed] = useState(false)
   const [showLoginNeedUpdate, setShowLoginNeedUpdate] = useState(false)
   const [loading, setLoading] = useState(false)
   const [token, setToken] = useState('')
   const [role, setRole] = useState('')
   const [kdUnit, setKdUnit] = useState('')
   const [statusUser, setStatusUser] = useState('')
   const [kodeTrader, setKodeTrader] = useState('')
   const [expired, setExpired] = useState('')
   const [nama, setNama] = useState('')
   const [userId, setUserId] = useState('')
   const [showForgotModal, setShowForgotModal] = useState(false);
   const [captchaText, setCaptchaText] = useState("");
   const [captchaInput, setCaptchaInput] = useState("");
   const [showCaptchaError, setShowCaptchaError] = useState(false);
   const [isMandatoryPrimer, setIsMandatoryPrimer] = useState('T')
   const [isMandatoryPasca, setIsMandatoryPasca] = useState('T')

   useEffect(() => {
      generateCaptcha();
   }, [])

   const generateCaptcha = () => {
      const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
      const text = Array.from({ length: 5 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
      setCaptchaText(text);
      setCaptchaInput("");
   };
   const onChangeUsername = e => {
      setUsername(e.target.value)
   }

   const onChangePassword = e => {
      setPassword(e.target.value)
   }

   const handleClickLogin = async () => {
      setLoading(true)
      if (captchaInput.toUpperCase() !== captchaText.toUpperCase()) {
         // alert("Captcha salah. Silakan coba lagi.");
         setShowCaptchaError(true);
         generateCaptcha();
         setCaptchaInput("");
         setLoading(false);
         return;
      }
      try {
         const response = await userService.login(username, password)
         if (response.data.statusCode === 200) {
            setToken(response.data.token)
            setRole(response.data.role)
            setKdUnit(response.data.kdUnit)
            setStatusUser(response.data.statusUser)
            setKodeTrader(response.data.kodeTrader)
            setExpired(response.data.expirationTime)
            setNama(response.data.nama)
            setUserId(response.data.userId)

            if (response.data.role === "2" || response.data.role === "3" || response.data.role === "7" || response.data.role === "9") {
               const resMandatory = await pbumkuService.getMandatoryUpt(response?.data?.kdUnit)
               setIsMandatoryPrimer(resMandatory?.data?.isMandatoryPrimer)
               setIsMandatoryPasca(resMandatory?.data?.isMandatoryPasca)
            }

            setShowLoginSuccess(true)

         } else if (response.data.statusCode === 500) {
            if (response.data.statusUser === '0') {
               setShowLoginNeedUpdate(true)
            } else {
               setShowLoginFailed(true)
               generateCaptcha();
            }
         } else {
            setShowLoginFailed(true)
            generateCaptcha();
         }
      } catch (error) {
         // console.log(error)
         setShowLoginFailed(true)
         generateCaptcha();
      }
      setLoading(false)
   }

   const handleClickLoginSuccess = () => {
      const expiryTime = new Date().getTime() + parseInt(expired)
      localStorage.setItem("token", token)
      localStorage.setItem("role", role)
      localStorage.setItem("kdUnit", kdUnit)
      localStorage.setItem("kodeTrader", kodeTrader)
      localStorage.setItem("nama", nama)
      localStorage.setItem("username", username)
      localStorage.setItem("expired", expiryTime)
      localStorage.setItem("userId", userId)
      localStorage.setItem("isMandatoryPrimer", isMandatoryPrimer)
      localStorage.setItem("isMandatoryPasca", isMandatoryPasca)
      history('/dashboard')
   }

   const handleClickLoginFailed = () => {
      setShowLoginFailed(false)
      setLoading(false)
      generateCaptcha();
   }

   const handleClickUpdatePassword = () => {
      setShowLoginNeedUpdate(false)
      setLoading(false)
      localStorage.setItem("username", username)
      localStorage.setItem("statusUser", statusUser)
      history('/update-password')
   }

   const handleClickCancel = () => {
      setShowLoginNeedUpdate(false)
      setLoading(false)
   }

   // const handleClickPpk = () => {
   //    window.open('https://siapmutu.kkp.go.id/ppk', '_blank')
   // }

   const handleClickRegister = () => {
      history('/registrasi')
   }
   const handleClickHome = () => {
      history('/')

   }

   return (
      <>
         <section className="login-content auth-modern">
            <div className="auth-form-pane">
               <div className="auth-topbar">
                  <Button variant="light" className="auth-back" onClick={handleClickHome}>
                     <i className="fa fa-arrow-left" /> <span>Landing Page</span>
                  </Button>
               </div>

               <div className="auth-card-wrap">
                  <Card className="card-transparent shadow-none mb-0 auth-card">
                     <Card.Body className="p-0">
                        <div className="auth-brand">
                           <img src={logoBrand} alt="SIAPMUTU - Sistem Informasi dan Aplikasi Pelayanan Mutu" />
                        </div>

                        <h3 className="auth-heading">Masuk ke akun Anda</h3>
                        <p className="auth-lead">Gunakan username dan password yang telah terdaftar.</p>

                        <Form>
                           <Row>
                              <Col lg="12">
                                 <Form.Group className="form-group mb-3">
                                    <Form.Label htmlFor="username" className="">Username</Form.Label>
                                    <div className="input-icon">
                                       <i className="fa fa-user" />
                                       <Form.Control type="username" className="" id="username" aria-describedby="username" placeholder="Masukkan username" defaultValue={username} onChange={onChangeUsername} />
                                    </div>
                                 </Form.Group >
                              </Col>
                              <Col lg="12" className="">
                                 <Form.Group className="form-group mb-3">
                                    <Form.Label htmlFor="password" className="">Password</Form.Label>
                                    <div className="input-icon">
                                       <i className="fa fa-lock" />
                                       <Form.Control type="password" className="" id="password" aria-describedby="password" placeholder="Masukkan password" defaultValue={password} onChange={onChangePassword} onKeyDown={(event) => { if (event.key === 'Enter') { handleClickLogin() } }} />
                                    </div>
                                 </Form.Group>
                              </Col>
                              <Col lg="12">
                                 <Form.Label className="">Verifikasi Captcha</Form.Label>
                                 <div className="captcha-box">
                                    <CaptchaCanvas text={captchaText} />
                                    <Button className="btn-refresh" variant="outline-primary" onClick={generateCaptcha} aria-label="Muat ulang captcha" title="Muat ulang captcha">
                                       <i className="fa fa-sync-alt" />
                                    </Button>
                                    <input
                                       type="text"
                                       className="form-control"
                                       placeholder="Ketik ulang teks disamping"
                                       value={captchaInput}
                                       onChange={(e) => setCaptchaInput(e.target.value)}
                                       onKeyDown={(event) => { if (event.key === 'Enter') { handleClickLogin() } }}
                                       required
                                    />
                                 </div>
                              </Col>
                           </Row>
                           <div className="auth-actions">
                              <Button onClick={() => handleClickLogin()} onKeyDown={(event) => { if (event.key === 'Enter') { handleClickLogin() } }} type="button" variant="primary" disabled={loading}>{loading ? <Spinner size="sm" /> : <i className="fa fa-sign-in-alt" />} Login</Button>
                              <Button onClick={() => handleClickRegister()} type="button" variant="outline-secondary" ><i className="fa fa-user-plus" /> Register</Button>
                           </div>
                           <a className="auth-forgot" onClick={() => setShowForgotModal(true)} type="button" >Lupa Password?</a>
                           <p className="auth-version">v 2.0.1 <br /> 2026.11.03-12.00</p>
                        </Form>
                     </Card.Body>
                  </Card>
               </div>
            </div>

            <div className="auth-visual" style={{ backgroundImage: `url(${auth1})` }}>
               <img src={logoIcon} alt="" className="auth-visual-icon" />
               {/* <span className="auth-visual-tag"><i className="fa fa-shield-alt" /> Badan Mutu KKP</span> */}
               <h2>Bring Safety Through Quality</h2>
               <p>Layanan sertifikasi dan pengawasan mutu hasil kelautan dan perikanan, terintegrasi dari hulu hingga hilir dalam satu platform.</p>
               <div className="auth-visual-points">
                  <span><i className="fa fa-check-circle" /> Layanan Sertifikasi Primer</span>
                  <span><i className="fa fa-check-circle" /> Layanan Sertifikasi Pascapanen</span>
                  <span><i className="fa fa-check-circle" /> Layanan SMKHP Ekspor</span>
                  <span><i className="fa fa-check-circle" /> Layanan Laboratorium</span>
               </div>
            </div>

            <ForgotPasswordModal
               show={showForgotModal}
               onClose={() => setShowForgotModal(false)}
            />
         </section>
         {
            showLoginSuccess &&
            <SweetAlert
               title="Login Success"
               success
               onConfirm={handleClickLoginSuccess}
               btnSize="sm"
               timeout={2000}
            />
         }
         {
            showLoginFailed &&
            <SweetAlert
               title="Login Gagal"
               danger
               onConfirm={handleClickLoginFailed}
               btnSize="sm"
            >User/Password Salah</SweetAlert>
         }
         {showCaptchaError && (
            <SweetAlert
               danger
               title="Captcha Salah"
               onConfirm={() => setShowCaptchaError(false)}
               btnSize="sm"
            >
               Teks captcha tidak cocok. Silakan coba lagi.
            </SweetAlert>
         )}
         {
            showLoginNeedUpdate &&
            <SweetAlert
               warning
               showCancel
               confirmBtnText="Update Password"
               confirmBtnBsStyle="warning"
               onConfirm={handleClickUpdatePassword}
               onCancel={handleClickCancel}
               btnSize="sm"
            >User Ditemukan Silakan Update Password terlebih dahulu</SweetAlert>
         }
      </>
   )
}

export default SignIn
